module.exports = __webpack_public_path__ + "static/media/md-return-left.34b30ae4.svg";